
// Seulement si le site n'est pas ouvert depuis l'écran d'accueil
// !window.navigator.standalone

var userAgent = navigator.userAgent;

// Vérifiez si l'utilisateur utilise Safari sur un appareil iOS
// cette méthode n'est pas infaillible et peut ne pas fonctionner avec toutes les versions de Safari et de iOS. 
// Si besoin d'une solution plus fiable, utiliser unebibliothèque tierce comme Mobile-Detect https://github.com/hgoebl/mobile-detect.js

if (!window.navigator.standalone && userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') == -1 && (userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1 || userAgent.indexOf('iPod') !== -1)) {

        //console.log('L\'utilisateur utilise Safari sur un appareil iOS qui prend en charge les PWA');

        var lastPopupDate = new Date(localStorage.getItem('lastPopupDate'));
        var now = new Date();
        var delay = 1 * 60 * 60 * 1000; // 1 heure en milisecondes

        if ( typeof lastPopupDate !== 'object' || lastPopupDate === null || (now.getTime() - lastPopupDate.getTime() > delay) ) {
            setTimeout(function(){
                    jQuery('#add-to-home-screen').show();
                    var now = new Date();
                    localStorage.setItem('lastPopupDate', now);
            }, 2000);              
        }

        jQuery('#add-to-home-screen').on('click', function (e) {
            e.preventDefault();

            jQuery(this).hide();

            var addtohomescreenclosebtn = document.getElementById("add-to-home-screen-close-btn");

            // Vérifiez si l'élément cliqué est enfant de l'élément de menu
            if (!addtohomescreenclosebtn.contains(e.target)) {
                jQuery('#add-to-home-screen-notice').show();
            }

        });

        jQuery('#add-to-home-screen-close-btn').on('click', function (e) {
            e.preventDefault();
            jQuery('#add-to-home-screen').hide();
            var now = new Date();
            localStorage.setItem('lastPopupDate', now);
        });

        jQuery('#add-to-home-screen-notice').on('click', function (e) {
            e.preventDefault();
            jQuery(this).hide();
        })


        document.body.addEventListener('click', closeAddToHomescreenMessage);
        // Créez la fonction de fermeture de menu
        function closeAddToHomescreenMessage(event) {

            var addtohomescreen = document.getElementById("add-to-home-screen");

            // Vérifiez si l'élément cliqué est enfant de l'élément de menu
            if (!addtohomescreen.contains(event.target)) {
                jQuery('#add-to-home-screen').hide();
                jQuery('#add-to-home-screen-notice').hide();
            }
        }

}